import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { BASE } from '../api/api'
import Axios from 'axios'
import cachios from 'cachios'
import Header from '../header/newheader'
import Footer from '../footer/newfooter';
import { List } from 'react-content-loader'
import grey from '../assets/grey.jpg'
import './news.css'

class News extends Component {
  constructor(props) {
    super(props);
    this.state = {
      news: '',
      img_source: '',
      limit: 15,
      offset: 0,
      next: false,
      prev: false
    }

  }
  topFunction() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
  //Next/previous click function
  handlePageClick = data => {
    if(localStorage.getItem('token'))
    this.checkexpiry()
    console.log(data, 'offset')
    if (data === 'next' && this.state.next === true) {
      this.setState({
        news: '',
      })
      this.apicall(this.state.offset + this.state.limit)
      this.setState({
        offset: this.state.offset + this.state.limit
      })
    }
    else if (data === 'prev' && this.state.prev === true) {
      this.setState({
        news: '',
      })
      this.setState({
        offset: this.state.offset - this.state.limit
      })
      this.apicall(this.state.offset - this.state.limit)
    }
  };

  
  signout() {
    localStorage.removeItem('token');
    localStorage.removeItem('expirytime');
    localStorage.removeItem('expiryref');
    // window.location.href = '/'

  }


  refreshexp(){
    let s = new Date();
    s.setSeconds(s.getSeconds()+1800);
    localStorage.setItem('expiryref', s)
  }


  checkexpiry(){
    if(localStorage.getItem('expiryref')){
      let expref=Date.parse(localStorage.getItem('expiryref'))
      let s = new Date();
      if(s>expref){
          this.signout()
      }
      else{
        this.refreshexp()
      }
      
    }
    else{
      this.signout()  
  }
  }


  componentWillMount() {
    if(localStorage.getItem('token'))
        this.checkexpiry()
    this.apicall(0);
    localStorage.removeItem('news');
    localStorage.removeItem('newsimg');
    this.topFunction();
  }

  apicall(id) {
    this.topFunction();
    //HIDE/SHOW  previous button
    if (id <= 0) {
      this.setState({
        prev: false,
      })
    }
    else {
      this.setState({
        prev: true
      })
    }

    Axios(BASE + 'jsonapi/node/news?include=field_source&sort=-changed&page[limit]=' + this.state.limit + '&page[offset]=' + (id + this.state.limit), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    })
      .then((data) => {
        console.log(data.data, 'next')
        //HIDE/SHOW  NEXT button
        if (data.data.data.length === 0) {
          this.setState({
            next: false,
          })
        }
        else {
          this.setState({
            next: true
          })
        }
      })

    cachios.get(BASE + 'jsonapi/node/news?include=field_source&sort=-changed&page[limit]=' + this.state.limit + '&page[offset]=' + id, {
      ttl: 500 /* seconds */,
    })
      .then((data) => {
        let i, j;
        let logoarray = []
        console.log(data.data.included)
        this.setState({
          news: data.data.data,
        })
        for (i = 0; i < data.data.data.length; i++) {
          if (data.data.data[i].relationships.field_source.data != null) {
            for (j = 0; j < data.data.included.length; j++) {
              if (data.data.data[i].relationships.field_source.data.id === data.data.included[j].id) {
                logoarray.push(grey)
                logoarray[i] = BASE + data.data.included[j].attributes.uri.url
              }
            }
          }
          else {
            logoarray.push(0);
            logoarray[i] = grey
          }
          this.setState({
            img_source: logoarray
          })
        }
      })
      .catch((err) => {
        console.log('not found')
      })
  }
  render() {
    return (
      <div className="newspage">
        <Header />
        <div className="page-title">
          <div className="title-wrapper">
            <div className="container">
              <h1 className="page-header">News</h1>
            </div>
          </div>
        </div>
        <div className="main-content listing">
          <div className="container newsrea">
            <div className="row">
              <div className="region region-content">
                <div className="listings">
                  {this.state.news ? this.state.news.map((news, index) => {
                    return (
                      <div className="title">
                        <span className="field-content">
                          {news.attributes.body ?
                            <Link to={{ pathname: '/news_desc/' + `${news.attributes.title.replace(/ /g, "-").toLowerCase()}` + '?nid=' + `${news.attributes.drupal_internal__nid}`, state: { search: false, link: news, source_img: this.state.img_source[index] ? this.state.img_source[index] : '' } }}>{news.attributes.title}</Link>
                            :
                            <div>{news.attributes.title}</div>
                          }
                        </span>
                      </div>
                    )
                  }) : <List />
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
        {this.state.news && (this.state.prev || this.state.next) ?
          <ul className="pagination">
            <li onClick={() => this.handlePageClick('prev')} className="previous disabled">
              <a style={{ color: this.state.prev ? '#165E84 ' : '', fontWeight: this.state.prev ? '500' : '', cursor: this.state.prev ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
            <li onClick={() => this.handlePageClick('next')} className="next"><a style={{ color: this.state.next ? '#165E84 ' : '', fontWeight: this.state.next ? '500' : '', cursor: this.state.next ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>
          </ul>
          : ''}
        <div id="wrapper-5" class="section subscribe_container">
          <div class="container">
            <div class="region region-wrapper-five">
              <div id="block-block-1" class="block block-block">
                <div class="content">
                  <p class="subscribe_news">Subscribe to our monthly newsletter</p>
                  <p><a class="waves-effect waves-light btn-large" href="">Subscribe</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div><Footer /></div>
      </div>
    )
  }
}


export default News;
